import { render, staticRenderFns } from "./productEdit.vue?vue&type=template&id=6efa4c6c&scoped=true"
import script from "./productEdit.vue?vue&type=script&lang=js"
export * from "./productEdit.vue?vue&type=script&lang=js"
import style0 from "./productEdit.vue?vue&type=style&index=0&id=6efa4c6c&prod&lang=scss"
import style1 from "./productEdit.vue?vue&type=style&index=1&id=6efa4c6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efa4c6c",
  null
  
)

export default component.exports